import React, { useState } from "react";
import LogoImg from "../../assets/images/logonew.png";
import TeamImg from "../../assets/images/team.png";
import { ToastContainer, toast, Bounce } from "react-toastify";
import api from "../../setupMiddleware";
import Popup from "../Common/Popup";

const ForgetPassword = () => {
  const [email, setEmail] = useState("");
  const [open, setOpen] = useState(false);

  const [emailError, setEmailError] = useState(false);

  const sendResendLink = async () => {
    if (!email) {
      setEmailError(true);
      toast.error("Please enter Email!", {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
      });
      return;
    } else {
      try {
        await api.post("/api/forgot-password", { email }).then((res) => {
          if (res && res.status === 200) {
            setOpen(true);
          }
        });
      } catch (error) {
        if (error) {
          toast.warning(error.response?.data?.message, {
            position: "top-left",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            transition: Bounce,
          });
        }
      }
    }
  };

  return (
    <div className="relative rounded-[20px] bg-[#f9f9f9] min-h-screen py-[40px]">
      <div className="max-w-[1340px] min-h-[calc(100vh-80px)] grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-[30%_60%] items-stretch justify-between px-8 m-auto gap-">
        {/* Left Section (1/3, form centered, footer bottom) */}
        <div className="flex flex-col justify-between items-center md:items-start px-5 py-8">
          {/* Centered Form Content */}
          <div className="flex w-full flex-col justify-center items-center md:items-start flex-grow">
            <div className="block w-full">
              {/* Logo & Title */}
              <div className="flex flex-col items-center md:items-start gap-2.5">
                <img
                  src={LogoImg}
                  className="w-[234px] h-[76px] object-cover"
                  alt="logo"
                />
                <p className="text-xl text-center md:text-left capitalize text-[#142b70]">
                  Forgot Password
                </p>
              </div>

              {/* Form Fields */}
              <div className="flex flex-col w-full gap-5 mt-12 mb-12">
                {/* Email */}
                <div className="flex flex-col gap-2.5">
                  <p className="text-xs text-[#142b70]">Email</p>
                  <input
                    className={`w-full h-[54px] p-2.5 rounded-xl bg-white border-2
                     border-[#ddd] ${
                       emailError ? "border-[#880000]" : ""
                     } focus:border-[#edc9b7] focus:outline-none shadow-[0px_44px_92px_0_rgba(159,159,159,0.25)]`}
                    type="text"
                    name="username"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
              </div>

              {/* Button */}
              <button
                className="w-full h-[53px] flex justify-center items-center px-[70px] py-3.5 rounded-md bg-[#de2b26] text-base font-medium text-white"
                onClick={sendResendLink}
              >
                Send Reset Link
              </button>
            </div>
          </div>
          <Popup
            isOpen={open}
            onClose={() => setOpen(false)}
            title="Email Sent!"
          >
            <div className="flex flex-col gap-6 my-[40px]">
              <p className="text-[#de2b26] text-center text-md mx-10">
                A password reset link has been sent to your registered email
                address. Please check your inbox, and if you don’t see it,
                kindly check your spam or junk folder.
              </p>
            </div>
            {/* Footer */}
            <div className="flex justify-end gap-4">
              <button
                onClick={() => setOpen(false)}
                className="px-10 py-3.5 rounded-md border bg-[#de2b26] text-white font-medium"
              >
                Close
              </button>
            </div>
          </Popup>
          {/* Footer at bottom */}
          <p className="mt-8 text-sm text-center md:text-left text-[#142b70]">
            © {new Date().getFullYear()} Money Maestro. All Rights Reserved.
          </p>
        </div>

        {/* Right Section (2/3, full height) */}
        <div className="hidden sm:flex bg-[#142b70] relative rounded-[40px] overflow-hidden justify-center items-center">
          <img src={TeamImg} alt="Team" className="w-full absolute bottom-0" />
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default ForgetPassword;
